// External
import _ from "lodash";
import React, { Fragment, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Tooltip } from "@toddle-edu/ds-web";

// Relative
import classes from "./BreadCrumbs.scss";

const BreadCrumbs = ({ hierarchy = [], onHierarchyClick, isMediaManager }) => {
  const hierarchyLength = _.size(hierarchy);

  const handleClick = useCallback(
    id => {
      onHierarchyClick(id);
    },
    [onHierarchyClick]
  );

  return (
    <div className={classes.container}>
      {_.map(hierarchy, ({ label, id }, idx) => {
        const isLast = hierarchyLength - 1 === idx;

        return (
          <Fragment key={id}>
            <Tooltip tooltip={label}>
              <div
                className={classNames(
                  "text-label",
                  isLast && !isMediaManager ? classes.current : classes.parent,
                  isLast ? classes.lastBreadcrumb : null
                )}
                onClick={() => handleClick(id)}
              >
                {label}
              </div>
            </Tooltip>
            {!isLast && (
              <span className={classNames(classes.separator)}>/</span>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

BreadCrumbs.propTypes = {
  hierarchy: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  onHierarchyClick: PropTypes.func,
  isMediaManager: PropTypes.bool,
};

BreadCrumbs.defaultProps = {
  hierarchy: [],
  onHierarchyClick: () => {},
  isMediaManager: false,
};

export default BreadCrumbs;
